import { useState } from 'react';

/** Claro/escuro: o do sistema, salvo escolha guardada no próprio equipamento (ver main.tsx). */
export function useTheme(): [boolean, () => void] {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains('dark'));
  const toggle = () => {
    const d = !dark;
    setDark(d);
    document.documentElement.classList.toggle('dark', d);
    try { localStorage.setItem('makila-pos-theme', d ? 'dark' : 'light'); } catch { /* sem armazenamento: fica só nesta sessão */ }
  };
  return [dark, toggle];
}
